import { render } from "./contaspagar-list-nova.vue?vue&type=template&id=0bdf37a4"
import script from "./contaspagar-list-nova.vue?vue&type=script&lang=js"
export * from "./contaspagar-list-nova.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__